import { jsx as e, Fragment as o, jsxs as n } from "react/jsx-runtime";
import { Select as r, Button as l } from "antd";
import { useRef as t, useEffect as i, useMemo as a, useCallback as u, useState as d } from "react";

var _c = function c() {
  return _c = Object.assign || function (e) {
    for (var o, n = 1, r = arguments.length; n < r; n++) {
      for (var l in o = arguments[n]) {
        Object.prototype.hasOwnProperty.call(o, l) && (e[l] = o[l]);
      }
    }

    return e;
  }, _c.apply(this, arguments);
};

function s(e, o) {
  var n = {};

  for (var r in e) {
    Object.prototype.hasOwnProperty.call(e, r) && o.indexOf(r) < 0 && (n[r] = e[r]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var l = 0;

    for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
      o.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
    }
  }

  return n;
}

function v(e, o, n) {
  if (n || 2 === arguments.length) for (var r, l = 0, t = o.length; l < t; l++) {
    !r && l in o || (r || (r = Array.prototype.slice.call(o, 0, l)), r[l] = o[l]);
  }
  return e.concat(r || Array.prototype.slice.call(o));
}

var p = [{
  name: "@yearly",
  value: "0 0 1 1 *"
}, {
  name: "@annually",
  value: "0 0 1 1 *"
}, {
  name: "@monthly",
  value: "0 0 1 * *"
}, {
  name: "@weekly",
  value: "0 0 * * 0"
}, {
  name: "@daily",
  value: "0 0 * * *"
}, {
  name: "@midnight",
  value: "0 0 * * *"
}, {
  name: "@hourly",
  value: "0 * * * *"
}],
    m = [{
  type: "minutes",
  min: 0,
  max: 59,
  total: 60
}, {
  type: "hours",
  min: 0,
  max: 23,
  total: 24
}, {
  type: "month-days",
  min: 1,
  max: 31,
  total: 31
}, {
  type: "months",
  min: 1,
  max: 12,
  total: 12,
  alt: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
}, {
  type: "week-days",
  min: 0,
  max: 6,
  total: 7,
  alt: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]
}],
    y = {
  everyText: "every",
  emptyMonths: "every month",
  emptyMonthDays: "every day of the month",
  emptyMonthDaysShort: "day of the month",
  emptyWeekDays: "every day of the week",
  emptyWeekDaysShort: "day of the week",
  emptyHours: "every hour",
  emptyMinutes: "every minute",
  emptyMinutesForHourPeriod: "every",
  yearOption: "year",
  monthOption: "month",
  weekOption: "week",
  dayOption: "day",
  hourOption: "hour",
  minuteOption: "minute",
  rebootOption: "reboot",
  prefixPeriod: "Every",
  prefixMonths: "in",
  prefixMonthDays: "on",
  prefixWeekDays: "on",
  prefixWeekDaysForMonthAndYearPeriod: "and",
  prefixHours: "at",
  prefixMinutes: ":",
  prefixMinutesForHourPeriod: "at",
  suffixMinutesForHourPeriod: "minute(s)",
  errorInvalidCron: "Invalid cron expression",
  clearButtonText: "Clear",
  weekDays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  altWeekDays: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
  altMonths: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
};

function f(e, o) {
  for (var n = [], r = e; r <= o; r++) {
    n.push(r);
  }

  return n;
}

function h(e) {
  return e.sort(function (e, o) {
    return e - o;
  }), e;
}

function w(e) {
  var o = [];
  return e.forEach(function (e) {
    o.indexOf(e) < 0 && o.push(e);
  }), o;
}

function O(e) {
  return Object.entries(e).filter(function (e) {
    var o = e[0],
        n = e[1];
    return o && n;
  }).map(function (e) {
    return e[0];
  }).join(" ");
}

function b(e, o) {
  e && e({
    type: "invalid_cron",
    description: o.errorInvalidCron || y.errorInvalidCron
  });
}

function g(e) {
  var o = parseInt(e, 10),
      n = Number(e);
  return o === n ? n : NaN;
}

function k(e, o, n, r, l, t, i, a, u, d, c, s, v, y) {
  n && n(void 0), o(!1);
  var O = !1;

  if (!e) {
    if ("always" === r || t && "for-default-value" === r) return;
    O = !0;
  }

  if (!O) {
    if (a && (!0 === a || a.includes(e))) {
      if ("@reboot" === e) return void y("reboot");
      var k = p.find(function (o) {
        return o.name === e;
      });
      k && (e = k.value);
    }

    try {
      var C = function (e) {
        if ("string" != typeof e) throw new Error("Invalid cron string");
        var o = e.replace(/\s+/g, " ").trim().split(" ");
        if (5 === o.length) return o.map(function (e, o) {
          return function (e, o) {
            if ("*" === e || "*/1" === e) return [];
            var n = h(w(M(function (e, o, n) {
              if (n) {
                e = e.toUpperCase();

                for (var r = 0; r < n.length; r++) {
                  e = e.replace(n[r], "".concat(r + o));
                }
              }

              return e;
            }(e, o.min, o.alt).split(",").map(function (n) {
              var r,
                  l = n.split("/");
              if (l.length > 2) throw new Error('Invalid value "'.concat(e, ' for "').concat(o.type, '"'));
              var t = l[0],
                  i = l[1];
              r = "*" === t ? f(o.min, o.max) : function (e, o, n) {
                var r = e.split("-");

                if (1 === r.length) {
                  var l = g(r[0]);
                  if (isNaN(l)) throw new Error('Invalid value "'.concat(o, '" for ').concat(n.type));
                  return [l];
                }

                if (2 === r.length) {
                  var t = g(r[0]),
                      i = g(r[1]);
                  if (isNaN(t) || isNaN(i)) throw new Error('Invalid value "'.concat(o, '" for ').concat(n.type));
                  if (i < t) throw new Error('Max range is less than min range in "'.concat(e, '" for ').concat(n.type));
                  return f(t, i);
                }

                throw new Error('Invalid value "'.concat(e, '" for ').concat(n.type));
              }(t, e, o);

              var a = function (e, o) {
                if (void 0 !== e) {
                  var n = g(e);
                  if (isNaN(n) || n < 1) throw new Error('Invalid interval step value "'.concat(e, '" for ').concat(o.type));
                  return n;
                }
              }(i, o),
                  u = function (e, o) {
                if (o) {
                  var n = e[0];
                  e = e.filter(function (e) {
                    return e % o == n % o || e === n;
                  });
                }

                return e;
              }(r, a);

              return u;
            }).flat(), o))),
                r = j(n, o);
            if (void 0 !== r) throw new Error('Value "'.concat(r, '" out of range for ').concat(o.type));
            if (n.length === o.total) return [];
            return n;
          }(e, m[o]);
        });
        throw new Error("Invalid cron string format");
      }(e),
          N = function (e) {
        if (e[3].length > 0) return "year";
        if (e[2].length > 0) return "month";
        if (e[4].length > 0) return "week";
        if (e[1].length > 0) return "day";
        if (e[0].length > 0) return "hour";
        return "minute";
      }(C);

      y(N), u(C[0]), d(C[1]), c(C[2]), s(C[3]), v(C[4]);
    } catch (e) {
      O = !0;
    }
  }

  O && (l.current = e, o(!0), b(n, i));
}

function C(e, o, n, r, l, t, i, a) {
  if ("reboot" === e) return "@reboot";

  var u = function (e, o, n) {
    return e.map(function (e, r) {
      var l,
          t = m[r],
          i = x(e, t),
          a = null == n ? void 0 : n[t.type];
      return N(i, t, null !== (l = null == a ? void 0 : a.humanizeValue) && void 0 !== l ? l : o);
    });
  }(["minute" !== e && t ? t : [], "minute" !== e && "hour" !== e && l ? l : [], "year" !== e && "month" !== e || !n ? [] : n, "year" === e && o ? o : [], "year" !== e && "month" !== e && "week" !== e || !r ? [] : r], i, a);

  return u.join(" ");
}

function N(e, o, n, r, l) {
  var t = "";
  if (function (e, o) {
    return e.length === o.max - o.min + 1;
  }(e, o) || 0 === e.length) t = "*";else {
    var i = function (e) {
      if (e.length > 2) {
        var o = e[1] - e[0];
        if (o > 1) return o;
      }
    }(e);

    t = i && function (e, o) {
      for (var n = 1; n < e.length; n++) {
        var r = e[n - 1];
        if (e[n] - r !== o) return !1;
      }

      return !0;
    }(e, i) ? function (e, o, n) {
      var r = P(e),
          l = S(e),
          t = e.length === (l - r) / n + 1;
      if (r === o.min && l + n > o.max && t) return !0;
      return !1;
    }(e, o, i) ? "*/".concat(i) : "".concat(D(P(e), o, n, r, l), "-").concat(D(S(e), o, n, r, l), "/").concat(i) : function (e) {
      var o = [],
          n = null;
      return e.forEach(function (e, r, l) {
        e !== l[r + 1] - 1 ? null !== n ? (o.push([n, e]), n = null) : o.push(e) : null === n && (n = e);
      }), o;
    }(e).map(function (e) {
      return Array.isArray(e) ? "".concat(D(e[0], o, n, r, l), "-").concat(D(e[1], o, n, r, l)) : D(e, o, n, r, l);
    }).join(",");
  }
  return t;
}

function D(e, o, n, r, l) {
  var t = e.toString(),
      i = o.type,
      a = o.alt,
      u = o.min,
      d = r && (!0 === r || r.includes(i)),
      c = "24-hour-clock" === l && ("hours" === i || "minutes" === i);

  if (n && "week-days" === i || n && "months" === i ? t = a[e - u] : e < 10 && (d || c) && (t = t.padStart(2, "0")), "hours" === i && "12-hour-clock" === l) {
    var s = e >= 12 ? "PM" : "AM",
        v = e % 12 || 12;
    v < 10 && d && (v = v.toString().padStart(2, "0")), t = "".concat(v).concat(s);
  }

  return t;
}

function x(e, o) {
  var n = h(w(M(e, o)));
  if (0 === n.length) return n;
  var r = j(n, o);
  if (void 0 !== r) throw new Error('Value "'.concat(r, '" out of range for ').concat(o.type));
  return n;
}

function M(e, o) {
  return "week-days" === o.type && (e = e.map(function (e) {
    return 7 === e ? 0 : e;
  })), e;
}

function j(e, o) {
  var n = e[0],
      r = e[e.length - 1];
  return n < o.min ? n : r > o.max ? r : void 0;
}

function P(e) {
  return e[0];
}

function S(e) {
  return e[e.length - 1];
}

var A = Object.freeze({
  __proto__: null,
  setValuesFromCronString: k,
  getCronStringFromValues: C,
  partToString: N,
  formatValue: D,
  parsePartArray: x
});

function F(n) {
  var l = n.value,
      i = n.grid,
      d = void 0 === i || i,
      p = n.optionsList,
      m = n.setValue,
      f = n.locale,
      w = n.className,
      b = n.humanizeLabels,
      g = n.disabled,
      k = n.readOnly,
      C = n.leadingZero,
      M = n.clockFormat,
      j = n.period,
      P = n.unit,
      S = n.periodicityOnDoubleClick,
      A = n.mode,
      F = n.allowClear,
      V = n.filterOption,
      E = void 0 === V ? function () {
    return !0;
  } : V,
      W = s(n, ["value", "grid", "optionsList", "setValue", "locale", "className", "humanizeLabels", "disabled", "readOnly", "leadingZero", "clockFormat", "period", "unit", "periodicityOnDoubleClick", "mode", "allowClear", "filterOption"]),
      H = a(function () {
    if (l && Array.isArray(l)) return l.map(function (e) {
      return e.toString();
    });
  }, [l]),
      T = a(function () {
    return p ? p.map(function (e, o) {
      return {
        value: (0 === P.min ? o : o + 1).toString(),
        label: e
      };
    }) : v([], Array(P.total), !0).map(function (e, o) {
      var n = 0 === P.min ? o : o + 1;
      return {
        value: n.toString(),
        label: D(n, P, b, C, M)
      };
    }).filter(E);
  }, [p, C, b, M]),
      I = JSON.stringify(f),
      L = u(function (n) {
    var r = n.value;
    if (!l || l[0] !== Number(r)) return e(o, {});
    var t = N(x(l, P), P, b, C, M),
        i = t.match(/^\*\/([0-9]+),?/) || [];
    return e("div", {
      children: i[1] ? "".concat(f.everyText || y.everyText, " ").concat(i[1]) : t
    });
  }, [l, I, b, C, M]),
      J = u(function (e) {
    var o = Array.isArray(e) ? h(e) : [e],
        n = o;
    l && (n = "single" === A ? [] : v([], l, !0), o.forEach(function (e) {
      var o = Number(e);
      n = l.some(function (e) {
        return e === o;
      }) ? n.filter(function (e) {
        return e !== o;
      }) : h(v(v([], n, !0), [o], !1));
    })), n.length === P.total ? m([]) : m(n);
  }, [m, l]),
      Z = u(function (e) {
    if (0 !== e && 1 !== e) {
      for (var o = P.total + P.min, n = [], r = P.min; r < o; r++) {
        r % e == 0 && n.push(r);
      }

      var t = l && n && l.length === n.length && l.every(function (e, o) {
        return e === n[o];
      }),
          i = n.length === T.length;
      m(i || t ? [] : n);
    } else m([]);
  }, [l, T, m]),
      z = t([]),
      U = u(function (e) {
    if (!k) {
      var o = z.current;
      o.push({
        time: new Date().getTime(),
        value: Number(e)
      });
      var n = window.setTimeout(function () {
        S && o.length > 1 && o[o.length - 1].time - o[o.length - 2].time < 300 ? o[o.length - 1].value === o[o.length - 2].value ? Z(Number(e)) : J([o[o.length - 2].value, o[o.length - 1].value]) : J(Number(e)), z.current = [];
      }, 300);
      return function () {
        window.clearTimeout(n);
      };
    }
  }, [z, J, Z, k, S]),
      B = u(function () {
    k || m([]);
  }, [m, k]),
      R = a(function () {
    var e;
    return O(((e = {
      "react-js-cron-select": !0,
      "react-js-cron-custom-select": !0
    })["".concat(w, "-select")] = !!w, e));
  }, [w]),
      Y = a(function () {
    var e;
    return O(((e = {
      "react-js-cron-select-dropdown": !0
    })["react-js-cron-select-dropdown-".concat(P.type)] = !0, e["react-js-cron-custom-select-dropdown"] = !0, e["react-js-cron-custom-select-dropdown-".concat(P.type)] = !0, e["react-js-cron-custom-select-dropdown-minutes-large"] = "minutes" === P.type && "hour" !== j && "day" !== j, e["react-js-cron-custom-select-dropdown-minutes-medium"] = "minutes" === P.type && ("day" === j || "hour" === j), e["react-js-cron-custom-select-dropdown-hours-twelve-hour-clock"] = "hours" === P.type && "12-hour-clock" === M, e["react-js-cron-custom-select-dropdown-grid"] = !!d, e["".concat(w, "-select-dropdown")] = !!w, e["".concat(w, "-select-dropdown-").concat(P.type)] = !!w, e));
  }, [w, d, M, j]);
  return e(r, _c({
    mode: "single" !== A || S ? "multiple" : void 0,
    allowClear: null != F ? F : !k,
    virtual: !1,
    open: !k && void 0,
    value: H,
    onClear: B,
    tagRender: L,
    className: R,
    popupClassName: Y,
    options: T,
    showSearch: !1,
    showArrow: !k,
    menuItemSelectedIcon: null,
    popupMatchSelectWidth: !1,
    onSelect: U,
    onDeselect: U,
    disabled: g,
    dropdownAlign: "minutes" !== P.type && "hours" !== P.type || "day" === j || "hour" === j ? void 0 : {
      points: ["tr", "br"]
    },
    "data-testid": "custom-select-".concat(P.type)
  }, W));
}

function V(o) {
  var r = o.value,
      l = o.setValue,
      t = o.locale,
      i = o.className,
      u = o.disabled,
      d = o.readOnly,
      s = o.leadingZero,
      v = o.clockFormat,
      p = o.period,
      f = o.periodicityOnDoubleClick,
      h = o.mode,
      w = o.allowClear,
      b = o.filterOption,
      g = a(function () {
    var e;
    return O(((e = {
      "react-js-cron-field": !0,
      "react-js-cron-hours": !0
    })["".concat(i, "-field")] = !!i, e["".concat(i, "-hours")] = !!i, e));
  }, [i]);
  return n("div", _c({
    className: g
  }, {
    children: ["" !== t.prefixHours && e("span", {
      children: t.prefixHours || y.prefixHours
    }), e(F, {
      placeholder: t.emptyHours || y.emptyHours,
      value: r,
      unit: m[1],
      setValue: l,
      locale: t,
      className: i,
      disabled: u,
      readOnly: d,
      leadingZero: s,
      clockFormat: v,
      period: p,
      periodicityOnDoubleClick: f,
      mode: h,
      allowClear: w,
      filterOption: b
    })]
  }));
}

function E(o) {
  var r = o.value,
      l = o.setValue,
      t = o.locale,
      i = o.className,
      u = o.disabled,
      d = o.readOnly,
      s = o.leadingZero,
      v = o.clockFormat,
      p = o.period,
      f = o.periodicityOnDoubleClick,
      h = o.mode,
      w = o.allowClear,
      b = o.filterOption,
      g = a(function () {
    var e;
    return O(((e = {
      "react-js-cron-field": !0,
      "react-js-cron-minutes": !0
    })["".concat(i, "-field")] = !!i, e["".concat(i, "-minutes")] = !!i, e));
  }, [i]);
  return n("div", _c({
    className: g
  }, {
    children: ["hour" === p ? "" !== t.prefixMinutesForHourPeriod && e("span", {
      children: t.prefixMinutesForHourPeriod || y.prefixMinutesForHourPeriod
    }) : "" !== t.prefixMinutes && e("span", {
      children: t.prefixMinutes || y.prefixMinutes
    }), e(F, {
      placeholder: "hour" === p ? t.emptyMinutesForHourPeriod || y.emptyMinutesForHourPeriod : t.emptyMinutes || y.emptyMinutes,
      value: r,
      unit: m[0],
      setValue: l,
      locale: t,
      className: i,
      disabled: u,
      readOnly: d,
      leadingZero: s,
      clockFormat: v,
      period: p,
      periodicityOnDoubleClick: f,
      mode: h,
      allowClear: w,
      filterOption: b
    }), "hour" === p && "" !== t.suffixMinutesForHourPeriod && e("span", {
      children: t.suffixMinutesForHourPeriod || y.suffixMinutesForHourPeriod
    })]
  }));
}

function W(o) {
  var r = o.value,
      l = o.setValue,
      t = o.locale,
      i = o.className,
      u = o.weekDays,
      d = o.disabled,
      s = o.readOnly,
      v = o.leadingZero,
      p = o.period,
      f = o.periodicityOnDoubleClick,
      h = o.mode,
      w = o.allowClear,
      b = o.filterOption,
      g = !u || 0 === u.length,
      k = a(function () {
    var e;
    return O(((e = {
      "react-js-cron-field": !0,
      "react-js-cron-month-days": !0,
      "react-js-cron-month-days-placeholder": !g
    })["".concat(i, "-field")] = !!i, e["".concat(i, "-month-days")] = !!i, e));
  }, [i, g]),
      C = JSON.stringify(t),
      N = a(function () {
    return g ? t.emptyMonthDays || y.emptyMonthDays : t.emptyMonthDaysShort || y.emptyMonthDaysShort;
  }, [g, C]);
  return !s || r && r.length > 0 || (!r || 0 === r.length) && (!u || 0 === u.length) ? n("div", _c({
    className: k
  }, {
    children: ["" !== t.prefixMonthDays && e("span", {
      children: t.prefixMonthDays || y.prefixMonthDays
    }), e(F, {
      placeholder: N,
      value: r,
      setValue: l,
      unit: m[2],
      locale: t,
      className: i,
      disabled: d,
      readOnly: s,
      leadingZero: v,
      period: p,
      periodicityOnDoubleClick: f,
      mode: h,
      allowClear: w,
      filterOption: b
    })]
  })) : null;
}

function H(o) {
  var r = o.value,
      l = o.setValue,
      t = o.locale,
      i = o.className,
      u = o.humanizeLabels,
      d = o.disabled,
      s = o.readOnly,
      v = o.period,
      p = o.periodicityOnDoubleClick,
      f = o.mode,
      h = o.allowClear,
      w = o.filterOption,
      b = t.months || y.months,
      g = a(function () {
    var e;
    return O(((e = {
      "react-js-cron-field": !0,
      "react-js-cron-months": !0
    })["".concat(i, "-field")] = !!i, e["".concat(i, "-months")] = !!i, e));
  }, [i]);
  return n("div", _c({
    className: g
  }, {
    children: ["" !== t.prefixMonths && e("span", {
      children: t.prefixMonths || y.prefixMonths
    }), e(F, {
      placeholder: t.emptyMonths || y.emptyMonths,
      optionsList: b,
      grid: !1,
      value: r,
      unit: _c(_c({}, m[3]), {
        alt: t.altMonths || y.altMonths
      }),
      setValue: l,
      locale: t,
      className: i,
      humanizeLabels: u,
      disabled: d,
      readOnly: s,
      period: v,
      periodicityOnDoubleClick: p,
      mode: f,
      allowClear: h,
      filterOption: w
    })]
  }));
}

function T(o) {
  var l = o.value,
      t = o.setValue,
      i = o.locale,
      d = o.className,
      s = o.disabled,
      v = o.readOnly,
      p = o.shortcuts,
      m = o.allowedPeriods,
      f = o.allowClear,
      h = [];
  m.includes("year") && h.push({
    value: "year",
    label: i.yearOption || y.yearOption
  }), m.includes("month") && h.push({
    value: "month",
    label: i.monthOption || y.monthOption
  }), m.includes("week") && h.push({
    value: "week",
    label: i.weekOption || y.weekOption
  }), m.includes("day") && h.push({
    value: "day",
    label: i.dayOption || y.dayOption
  }), m.includes("hour") && h.push({
    value: "hour",
    label: i.hourOption || y.hourOption
  }), m.includes("minute") && h.push({
    value: "minute",
    label: i.minuteOption || y.minuteOption
  }), m.includes("reboot") && p && (!0 === p || p.includes("@reboot")) && h.push({
    value: "reboot",
    label: i.rebootOption || y.rebootOption
  });
  var w = u(function (e) {
    v || t(e);
  }, [t, v]),
      b = a(function () {
    var e;
    return O(((e = {
      "react-js-cron-field": !0,
      "react-js-cron-period": !0
    })["".concat(d, "-field")] = !!d, e["".concat(d, "-period")] = !!d, e));
  }, [d]),
      g = a(function () {
    var e;
    return O(((e = {
      "react-js-cron-select": !0,
      "react-js-cron-select-no-prefix": "" === i.prefixPeriod
    })["".concat(d, "-select")] = !!d, e));
  }, [d, i.prefixPeriod]),
      k = a(function () {
    var e;
    return O(((e = {
      "react-js-cron-select-dropdown": !0,
      "react-js-cron-select-dropdown-period": !0
    })["".concat(d, "-select-dropdown")] = !!d, e["".concat(d, "-select-dropdown-period")] = !!d, e));
  }, [d]);
  return n("div", _c({
    className: b
  }, {
    children: ["" !== i.prefixPeriod && e("span", {
      children: i.prefixPeriod || y.prefixPeriod
    }), e(r, {
      defaultValue: l,
      value: l,
      onChange: w,
      options: h,
      className: g,
      popupClassName: k,
      disabled: s,
      showArrow: !v,
      open: !v && void 0,
      "data-testid": "select-period",
      allowClear: f
    }, JSON.stringify(i))]
  }));
}

function I(o) {
  var r = o.value,
      l = o.setValue,
      t = o.locale,
      i = o.className,
      u = o.humanizeLabels,
      d = o.monthDays,
      s = o.disabled,
      v = o.readOnly,
      p = o.period,
      f = o.periodicityOnDoubleClick,
      h = o.mode,
      w = o.allowClear,
      b = o.filterOption,
      g = t.weekDays || y.weekDays,
      k = "week" === p || !d || 0 === d.length,
      C = a(function () {
    var e;
    return O(((e = {
      "react-js-cron-field": !0,
      "react-js-cron-week-days": !0,
      "react-js-cron-week-days-placeholder": !k
    })["".concat(i, "-field")] = !!i, e["".concat(i, "-week-days")] = !!i, e));
  }, [i, k]),
      N = JSON.stringify(t),
      D = a(function () {
    return k ? t.emptyWeekDays || y.emptyWeekDays : t.emptyWeekDaysShort || y.emptyWeekDaysShort;
  }, [k, N]),
      x = "week" === p || !v || r && r.length > 0 || (!r || 0 === r.length) && (!d || 0 === d.length),
      M = !v || d && d.length > 0 || (!d || 0 === d.length) && (!r || 0 === r.length);
  return x ? n("div", _c({
    className: C
  }, {
    children: ["" !== t.prefixWeekDays && ("week" === p || !M) && e("span", {
      children: t.prefixWeekDays || y.prefixWeekDays
    }), "" !== t.prefixWeekDaysForMonthAndYearPeriod && "week" !== p && M && e("span", {
      children: t.prefixWeekDaysForMonthAndYearPeriod || y.prefixWeekDaysForMonthAndYearPeriod
    }), e(F, {
      placeholder: D,
      optionsList: g,
      grid: !1,
      value: r,
      unit: _c(_c({}, m[4]), {
        alt: t.altWeekDays || y.altWeekDays
      }),
      setValue: l,
      locale: t,
      className: i,
      humanizeLabels: u,
      disabled: s,
      readOnly: v,
      period: p,
      periodicityOnDoubleClick: f,
      mode: h,
      allowClear: w,
      filterOption: b
    })]
  })) : null;
}

function L(r) {
  var v,
      p,
      m,
      f,
      h,
      w,
      g,
      N,
      D,
      x,
      M,
      j,
      P,
      S,
      A,
      F,
      L,
      J,
      Z,
      z,
      U,
      B,
      R,
      Y,
      _,
      G,
      q,
      K,
      Q,
      X,
      $,
      ee,
      oe,
      ne,
      re,
      le,
      te,
      ie,
      ae,
      ue,
      de,
      ce,
      se,
      ve,
      pe,
      me,
      ye,
      fe,
      he,
      we,
      Oe,
      be,
      ge,
      ke,
      Ce,
      Ne,
      De,
      xe,
      Me,
      je,
      Pe,
      Se,
      Ae,
      Fe,
      Ve,
      Ee,
      We,
      He,
      Te,
      Ie,
      Le,
      Je = r.clearButton,
      Ze = void 0 === Je || Je,
      ze = r.clearButtonProps,
      Ue = void 0 === ze ? {} : ze,
      Be = r.clearButtonAction,
      Re = void 0 === Be ? "fill-with-every" : Be,
      Ye = r.locale,
      _e = void 0 === Ye ? y : Ye,
      Ge = r.value,
      qe = void 0 === Ge ? "" : Ge,
      Ke = r.setValue,
      Qe = r.displayError,
      Xe = void 0 === Qe || Qe,
      $e = r.onError,
      eo = r.className,
      oo = r.defaultPeriod,
      no = void 0 === oo ? "day" : oo,
      ro = r.allowEmpty,
      lo = void 0 === ro ? "for-default-value" : ro,
      to = r.humanizeLabels,
      io = void 0 === to || to,
      ao = r.humanizeValue,
      uo = void 0 !== ao && ao,
      co = r.disabled,
      so = void 0 !== co && co,
      vo = r.readOnly,
      po = void 0 !== vo && vo,
      mo = r.leadingZero,
      yo = void 0 !== mo && mo,
      fo = r.shortcuts,
      ho = void 0 === fo ? ["@yearly", "@annually", "@monthly", "@weekly", "@daily", "@midnight", "@hourly"] : fo,
      wo = r.clockFormat,
      Oo = r.periodicityOnDoubleClick,
      bo = void 0 === Oo || Oo,
      go = r.mode,
      ko = void 0 === go ? "multiple" : go,
      Co = r.allowedDropdowns,
      No = void 0 === Co ? ["period", "months", "month-days", "week-days", "hours", "minutes"] : Co,
      Do = r.allowedPeriods,
      xo = void 0 === Do ? ["year", "month", "week", "day", "hour", "minute", "reboot"] : Do,
      Mo = r.allowClear,
      jo = r.dropdownsConfig,
      Po = t(qe),
      So = t(no),
      Ao = d(),
      Fo = Ao[0],
      Vo = Ao[1],
      Eo = d(),
      Wo = Eo[0],
      Ho = Eo[1],
      To = d(),
      Io = To[0],
      Lo = To[1],
      Jo = d(),
      Zo = Jo[0],
      zo = Jo[1],
      Uo = d(),
      Bo = Uo[0],
      Ro = Uo[1],
      Yo = d(),
      _o = Yo[0],
      Go = Yo[1],
      qo = d(!1),
      Ko = qo[0],
      Qo = qo[1],
      Xo = d(!1),
      $o = Xo[0],
      en = Xo[1],
      on = function (e) {
    var o = t(e);
    return i(function () {
      o.current = e;
    }, [e]), o.current;
  }($o),
      nn = JSON.stringify(_e);

  i(function () {
    k(qe, Qo, $e, lo, Po, !0, _e, ho, Go, Ro, Ho, Lo, zo, Vo);
  }, []), i(function () {
    qe !== Po.current && k(qe, Qo, $e, lo, Po, !1, _e, ho, Go, Ro, Ho, Lo, zo, Vo);
  }, [qe, Po, nn, lo, ho]), i(function () {
    if (!(Fo || _o || Io || Wo || Zo || Bo) || $o || on) $o && en(!1);else {
      var e = Fo || So.current,
          o = C(e, Io, Wo, Zo, Bo, _o, uo, jo);
      Ke(o, {
        selectedPeriod: e
      }), Po.current = o, $e && $e(void 0), Qo(!1);
    }
  }, [Fo, Wo, Io, Zo, Bo, _o, uo, $o, jo]);
  var rn = u(function () {
    Ho(void 0), Lo(void 0), zo(void 0), Ro(void 0), Go(void 0);
    var e = "",
        o = "reboot" !== Fo && Fo ? Fo : So.current;
    (o !== Fo && Vo(o), "fill-with-every" === Re) && (e = C(o, void 0, void 0, void 0, void 0, void 0, void 0, void 0));
    Ke(e, {
      selectedPeriod: o
    }), Po.current = e, en(!0), "never" === lo && "empty" === Re ? (Qo(!0), b($e, _e)) : ($e && $e(void 0), Qo(!1));
  }, [Fo, Ke, $e, Re]),
      ln = a(function () {
    var e;
    return O(((e = {
      "react-js-cron": !0,
      "react-js-cron-error": Ko && Xe,
      "react-js-cron-disabled": so,
      "react-js-cron-read-only": po
    })["".concat(eo)] = !!eo, e["".concat(eo, "-error")] = Ko && Xe && !!eo, e["".concat(eo, "-disabled")] = so && !!eo, e["".concat(eo, "-read-only")] = po && !!eo, e));
  }, [eo, Ko, Xe, so, po]),
      tn = Ue.className,
      an = s(Ue, ["className"]),
      un = a(function () {
    var e;
    return O(((e = {
      "react-js-cron-clear-button": !0
    })["".concat(eo, "-clear-button")] = !!eo, e["".concat(tn)] = !!tn, e));
  }, [eo, tn]),
      dn = JSON.stringify(an),
      cn = a(function () {
    return Ze && !po ? e(l, _c({
      className: un,
      danger: !0,
      type: "primary",
      disabled: so
    }, an, {
      onClick: rn
    }, {
      children: _e.clearButtonText || y.clearButtonText
    })) : null;
  }, [Ze, po, nn, un, so, dn, rn]),
      sn = Fo || So.current;
  return n("div", _c({
    className: ln
  }, {
    children: [No.includes("period") && e(T, {
      value: sn,
      setValue: Vo,
      locale: _e,
      className: eo,
      disabled: null !== (p = null === (v = null == jo ? void 0 : jo.period) || void 0 === v ? void 0 : v.disabled) && void 0 !== p ? p : so,
      readOnly: null !== (f = null === (m = null == jo ? void 0 : jo.period) || void 0 === m ? void 0 : m.readOnly) && void 0 !== f ? f : po,
      shortcuts: ho,
      allowedPeriods: xo,
      allowClear: null !== (w = null === (h = null == jo ? void 0 : jo.period) || void 0 === h ? void 0 : h.allowClear) && void 0 !== w ? w : Mo
    }), "reboot" === sn ? cn : n(o, {
      children: ["year" === sn && No.includes("months") && e(H, {
        value: Io,
        setValue: Lo,
        locale: _e,
        className: eo,
        humanizeLabels: null !== (N = null === (g = null == jo ? void 0 : jo.months) || void 0 === g ? void 0 : g.humanizeLabels) && void 0 !== N ? N : io,
        disabled: null !== (x = null === (D = null == jo ? void 0 : jo.months) || void 0 === D ? void 0 : D.disabled) && void 0 !== x ? x : so,
        readOnly: null !== (j = null === (M = null == jo ? void 0 : jo.months) || void 0 === M ? void 0 : M.readOnly) && void 0 !== j ? j : po,
        period: sn,
        periodicityOnDoubleClick: null !== (S = null === (P = null == jo ? void 0 : jo.months) || void 0 === P ? void 0 : P.periodicityOnDoubleClick) && void 0 !== S ? S : bo,
        mode: null !== (F = null === (A = null == jo ? void 0 : jo.months) || void 0 === A ? void 0 : A.mode) && void 0 !== F ? F : ko,
        allowClear: null !== (J = null === (L = null == jo ? void 0 : jo.months) || void 0 === L ? void 0 : L.allowClear) && void 0 !== J ? J : Mo,
        filterOption: null === (Z = null == jo ? void 0 : jo.months) || void 0 === Z ? void 0 : Z.filterOption
      }), ("year" === sn || "month" === sn) && No.includes("month-days") && e(W, {
        value: Wo,
        setValue: Ho,
        locale: _e,
        className: eo,
        weekDays: Zo,
        disabled: null !== (U = null === (z = null == jo ? void 0 : jo["month-days"]) || void 0 === z ? void 0 : z.disabled) && void 0 !== U ? U : so,
        readOnly: null !== (R = null === (B = null == jo ? void 0 : jo["month-days"]) || void 0 === B ? void 0 : B.readOnly) && void 0 !== R ? R : po,
        leadingZero: null !== (_ = null === (Y = null == jo ? void 0 : jo["month-days"]) || void 0 === Y ? void 0 : Y.leadingZero) && void 0 !== _ ? _ : yo,
        period: sn,
        periodicityOnDoubleClick: null !== (q = null === (G = null == jo ? void 0 : jo["month-days"]) || void 0 === G ? void 0 : G.periodicityOnDoubleClick) && void 0 !== q ? q : bo,
        mode: null !== (Q = null === (K = null == jo ? void 0 : jo["month-days"]) || void 0 === K ? void 0 : K.mode) && void 0 !== Q ? Q : ko,
        allowClear: null !== ($ = null === (X = null == jo ? void 0 : jo["month-days"]) || void 0 === X ? void 0 : X.allowClear) && void 0 !== $ ? $ : Mo,
        filterOption: null === (ee = null == jo ? void 0 : jo["month-days"]) || void 0 === ee ? void 0 : ee.filterOption
      }), ("year" === sn || "month" === sn || "week" === sn) && No.includes("week-days") && e(I, {
        value: Zo,
        setValue: zo,
        locale: _e,
        className: eo,
        humanizeLabels: null !== (ne = null === (oe = null == jo ? void 0 : jo["week-days"]) || void 0 === oe ? void 0 : oe.humanizeLabels) && void 0 !== ne ? ne : io,
        monthDays: Wo,
        disabled: null !== (le = null === (re = null == jo ? void 0 : jo["week-days"]) || void 0 === re ? void 0 : re.disabled) && void 0 !== le ? le : so,
        readOnly: null !== (ie = null === (te = null == jo ? void 0 : jo["week-days"]) || void 0 === te ? void 0 : te.readOnly) && void 0 !== ie ? ie : po,
        period: sn,
        periodicityOnDoubleClick: null !== (ue = null === (ae = null == jo ? void 0 : jo["week-days"]) || void 0 === ae ? void 0 : ae.periodicityOnDoubleClick) && void 0 !== ue ? ue : bo,
        mode: null !== (ce = null === (de = null == jo ? void 0 : jo["week-days"]) || void 0 === de ? void 0 : de.mode) && void 0 !== ce ? ce : ko,
        allowClear: null !== (ve = null === (se = null == jo ? void 0 : jo["week-days"]) || void 0 === se ? void 0 : se.allowClear) && void 0 !== ve ? ve : Mo,
        filterOption: null === (pe = null == jo ? void 0 : jo["week-days"]) || void 0 === pe ? void 0 : pe.filterOption
      }), n("div", {
        children: ["minute" !== sn && "hour" !== sn && No.includes("hours") && e(V, {
          value: Bo,
          setValue: Ro,
          locale: _e,
          className: eo,
          disabled: null !== (ye = null === (me = null == jo ? void 0 : jo.hours) || void 0 === me ? void 0 : me.disabled) && void 0 !== ye ? ye : so,
          readOnly: null !== (he = null === (fe = null == jo ? void 0 : jo.hours) || void 0 === fe ? void 0 : fe.readOnly) && void 0 !== he ? he : po,
          leadingZero: null !== (Oe = null === (we = null == jo ? void 0 : jo.hours) || void 0 === we ? void 0 : we.leadingZero) && void 0 !== Oe ? Oe : yo,
          clockFormat: wo,
          period: sn,
          periodicityOnDoubleClick: null !== (ge = null === (be = null == jo ? void 0 : jo.hours) || void 0 === be ? void 0 : be.periodicityOnDoubleClick) && void 0 !== ge ? ge : bo,
          mode: null !== (Ce = null === (ke = null == jo ? void 0 : jo.hours) || void 0 === ke ? void 0 : ke.mode) && void 0 !== Ce ? Ce : ko,
          allowClear: null !== (De = null === (Ne = null == jo ? void 0 : jo.hours) || void 0 === Ne ? void 0 : Ne.allowClear) && void 0 !== De ? De : Mo,
          filterOption: null === (xe = null == jo ? void 0 : jo.hours) || void 0 === xe ? void 0 : xe.filterOption
        }), "minute" !== sn && No.includes("minutes") && e(E, {
          value: _o,
          setValue: Go,
          locale: _e,
          period: sn,
          className: eo,
          disabled: null !== (je = null === (Me = null == jo ? void 0 : jo.minutes) || void 0 === Me ? void 0 : Me.disabled) && void 0 !== je ? je : so,
          readOnly: null !== (Se = null === (Pe = null == jo ? void 0 : jo.minutes) || void 0 === Pe ? void 0 : Pe.readOnly) && void 0 !== Se ? Se : po,
          leadingZero: null !== (Fe = null === (Ae = null == jo ? void 0 : jo.minutes) || void 0 === Ae ? void 0 : Ae.leadingZero) && void 0 !== Fe ? Fe : yo,
          clockFormat: wo,
          periodicityOnDoubleClick: null !== (Ee = null === (Ve = null == jo ? void 0 : jo.minutes) || void 0 === Ve ? void 0 : Ve.periodicityOnDoubleClick) && void 0 !== Ee ? Ee : bo,
          mode: null !== (He = null === (We = null == jo ? void 0 : jo.minutes) || void 0 === We ? void 0 : We.mode) && void 0 !== He ? He : ko,
          allowClear: null !== (Ie = null === (Te = null == jo ? void 0 : jo.minutes) || void 0 === Te ? void 0 : Te.allowClear) && void 0 !== Ie ? Ie : Mo,
          filterOption: null === (Le = null == jo ? void 0 : jo.minutes) || void 0 === Le ? void 0 : Le.filterOption
        }), cn]
      })]
    })]
  }));
}

export { L as Cron, A as converter, L as default };